<template>
    <footer class="h-48 flex items-end bg-blue-700 min-w-full p-10 md:p-10">
        <div class="min-w-full flex flex-col-reverse md:flex-row justify-around md:justify-between items-center md:items-end h-20 text-white">
            <div>
                &copy;
                Liquidity Flow.
                All rights reserved.
            </div>
            <!-- &mdash; -->
            <div>
                Made in Vienna, Austria
            </div>
            <!-- &ndash; -->
            <div>
                <router-link
                    :to="{ name: 'Imprint' }"
                    target="_blank"
                >
                    Imprint
                </router-link>
                |
                <router-link
                    :to="{ name: 'Privacy' }"
                    target="_blank"
                >
                    Privacy
                </router-link>
                |
                <router-link
                    :to="{ name: 'TermsOfUse' }"
                    target="_blank"
                >
                    Terms of Use
                </router-link>
            </div>
        </div>
    </footer>
</template>

<script>
import { mapFields } from 'vuex-map-fields';

export default {
    name: 'Footer',
    data() {
        return {
        };
    },
    computed: {
        ...mapFields([
            'user.uid',
        ]),
    },
    methods: {
    },
};
</script>

<style>

</style>
